module.exports = __webpack_public_path__ + "bb2616ac9ed8edcd5b3f85edc3e080b9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/FI.svg
// module id = +EED
// module chunks = 0